module.exports = __webpack_public_path__ + "img/compact.bab7e200.png";